import { Input, Typography } from '@mui/material';
import { color } from '@/colors';

interface EditableListItemProps {
  isEditing: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
  displayValue: string;
}

export function EditableListItem({
  isEditing,
  value = '',
  onChange,
  onConfirm,
  onCancel,
  displayValue,
}: EditableListItemProps) {
  if (!isEditing) {
    return (
      <Typography variant="body-sm-md" component="div">
        {displayValue}
      </Typography>
    );
  }

  return (
    <Input
      inputRef={(input: HTMLInputElement) => input && input.focus()}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onFocus={(e) => e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (value.trim()) void onConfirm?.();
          else void onCancel?.();
        }
        if (e.key === 'Escape') {
          e.preventDefault();
          void onCancel?.();
        }
      }}
      onBlur={() => void onCancel?.()}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      sx={{
        color: 'inherit',
        '&::before': { borderBottomColor: color.White64_T },
        '&::after': { borderBottomColor: color.White64_T },
        '& input': {
          color: 'inherit',
          '&::selection': { backgroundColor: color.TextSelection },
        },
      }}
    />
  );
}
